export default __webpack_public_path__ + "static/media/Dog.4edab8ec.png";